import { PageHero } from '@components/common';

export default function TermsOfServicePage() {
  return (
    <>
      <PageHero
        title="Terms of Service"
        eyebrow="Legal"
        seoTitle="Terms of Service | The CISO Network"
        seoDescription="Our terms of service govern your use of The CISO Network website and services."
      />

      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="prose prose-lg max-w-none text-muted-foreground">
            <p className="text-sm text-muted-foreground mb-8">Last updated: January 2026</p>

            <h2 className="text-xl font-heading font-semibold text-foreground mt-8 mb-4">
              1. Agreement to Terms
            </h2>
            <p>
              By accessing or using The CISO Network&apos;s website and services, you agree to be
              bound by these Terms of Service. If you disagree with any part of these terms, you may
              not access our services.
            </p>

            <h2 className="text-xl font-heading font-semibold text-foreground mt-8 mb-4">
              2. Description of Services
            </h2>
            <p>
              The CISO Network provides fractional Chief Information Security Officer (CISO)
              services, cybersecurity consulting, and related advisory services to businesses. Our
              services include but are not limited to:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Security strategy and roadmap development</li>
              <li>Compliance and governance advisory</li>
              <li>Risk assessment and management</li>
              <li>Incident response planning</li>
              <li>Board reporting and executive communication</li>
            </ul>

            <h2 className="text-xl font-heading font-semibold text-foreground mt-8 mb-4">
              3. Client Responsibilities
            </h2>
            <p>As a client, you agree to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Provide accurate and complete information</li>
              <li>Maintain the confidentiality of any credentials or access provided</li>
              <li>Cooperate with our consultants in good faith</li>
              <li>Inform us of any material changes to your business or security environment</li>
              <li>Pay all fees in accordance with the agreed payment terms</li>
            </ul>

            <h2 className="text-xl font-heading font-semibold text-foreground mt-8 mb-4">
              4. Confidentiality
            </h2>
            <p>
              We take confidentiality seriously. Our consultants are bound by strict non-disclosure
              agreements, and we implement appropriate measures to protect your confidential
              information. Details of our confidentiality obligations are set out in our Client
              Agreement.
            </p>

            <h2 className="text-xl font-heading font-semibold text-foreground mt-8 mb-4">
              5. Limitation of Liability
            </h2>
            <p>
              While we strive to provide excellent service, our liability is limited to the fees
              paid for the specific services in question. We are not liable for any indirect,
              consequential, or punitive damages arising from your use of our services.
            </p>

            <h2 className="text-xl font-heading font-semibold text-foreground mt-8 mb-4">
              6. Intellectual Property
            </h2>
            <p>
              All materials, reports, and deliverables created specifically for you become your
              property upon full payment. However, we retain the right to use general methodologies,
              frameworks, and non-confidential knowledge gained during our engagement.
            </p>

            <h2 className="text-xl font-heading font-semibold text-foreground mt-8 mb-4">
              7. Governing Law
            </h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of England
              and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts
              of England and Wales.
            </p>

            <h2 className="text-xl font-heading font-semibold text-foreground mt-8 mb-4">
              8. Changes to Terms
            </h2>
            <p>
              We reserve the right to modify these terms at any time. We will notify clients of any
              material changes. Continued use of our services after such changes constitutes
              acceptance of the new terms.
            </p>

            <h2 className="text-xl font-heading font-semibold text-foreground mt-8 mb-4">
              9. Contact Information
            </h2>
            <p>For questions about these Terms of Service, please contact us at:</p>
            <p className="mt-4">
              <strong>Email:</strong> legal@thecisonetwork.com
              <br />
              <strong>Company:</strong> The CISO Network Ltd, company number 17182533
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
